__turbopack_context__.v({
  "arrow": "PopoverTrigger-module__jepPsG__arrow",
  "lc-popover-2": "PopoverTrigger-module__jepPsG__lc-popover-2",
});
